export { default as IconArrowRight } from './icon-arrow-right.jsx';
export { default as IconBurger } from './icon-burger.jsx';
export { default as IconChevronDown } from './icon-chevron-down.jsx';
export { default as IconChevronLeft } from './icon-chevron-left.jsx';
export { default as IconChevronRight } from './icon-chevron-right.jsx';
export { default as IconChevronUp } from './icon-chevron-up.jsx';
export { default as IconCross } from './icon-cross.jsx';
export { default as IconPlay } from './icon-play.jsx';
export { default as IconSearch } from './icon-search.jsx';
export { default as IconUniPlan } from './icon-uniplan.jsx';
